export const VNMODE_SET_MODE = 'VNMODE_SET_MODE'
export const VNMODE_SET_DEVICE_ID = 'VNMODE_SET_DEVICE_ID'
export const VNMODE_SET_PORTICO_AUTH_TOKENS = 'VNMODE_SET_PORTICO_AUTH_TOKENS'
export const VNMODE_SET_SUMMIT_MODE = 'VNMODE_SET_SUMMIT_MODE'
